import { createContext } from 'react';

import type { XYChartToolbar } from '../types/xy-chart.js';

export const XYChartToolbarContext = createContext<XYChartToolbar | undefined>(
  undefined,
);
XYChartToolbarContext['displayName'] = 'XYChartToolbarContext';
